import axios from 'axios'

export const serverHost = import.meta.env.VITE_API_URL

axios.defaults.baseURL = serverHost
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'
axios.defaults.headers.post['Stoplight-Client-Id'] = 'stoplight-web'

// Requests made with this client do not inherit the authenticated interceptors.
const cleanAxios = axios.create()
cleanAxios.interceptors.request.clear()

export { axios, cleanAxios }
